import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { JSX } from "react";

import { PLATFORM_LABELS } from "../../types.js";
import type { ScheduledPost } from "../../types.js";
import { localTime } from "../calendar-utils.js";

/** Compact "HH:mm · Platform" chip shown inside a calendar day cell. Extracted
 * from `ScheduleCalendar.tsx`. */
export function CalendarChip({ post }: { post: ScheduledPost }): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        borderRadius: 0.5,
        px: 0.5,
        py: 0.125,
        bgcolor: (t) => alpha(t.palette.primary.main, 0.08),
        overflow: "hidden",
      }}
    >
      <Box
        component="span"
        sx={{ fontSize: 10, fontFamily: "ui-monospace, monospace", color: "text.secondary", flexShrink: 0 }}
      >
        {localTime(post.scheduled_for)}
      </Box>
      <Box
        component="span"
        sx={{
          fontSize: 10,
          color: "text.primary",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {PLATFORM_LABELS[post.platform] ?? post.platform}
      </Box>
    </Box>
  );
}
